import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1rem',
    width: '100%',

    '& .icon': {
      marginLeft: '0.5rem',
      fontSize: theme.size.lg,
      color: theme.palette.primary.main
    }
  },

  header: {
    paddingLeft: '1rem',
    fontSize: theme.size.lg,
    color: theme.palette.primary.main
  },

  add: {
    borderBottom: 'none',
    paddingTop: '0',
    paddingBottom: '0'
  }
}))

export default useStyles
